/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 18/08/2020.
 * @module PRINTER CONSTANTS
 */

// Action constants
export const MODULE_NAME = "PRINTER/";

// Actions type
export const BROWSE_PRINTER = `${MODULE_NAME}BROWSE_PRINTER`;
export const BROWSE_PRINTER_TAG = `${MODULE_NAME}BROWSE_PRINTER_TAG`;
export const BROWSE_PRINTER_STATUS = `${MODULE_NAME}BROWSE_PRINTER_STATUS`;
export const BROWSE_PRINTER_REPAIR_BY_WEEK = `${MODULE_NAME}BROWSE_PRINTER_REPAIR_BY_WEEK`;
export const BROWSE_PRINTER_RECENT_DATE = `${MODULE_NAME}BROWSE_PRINTER_RECENT_DATE`;
export const BROWSE_PRINTER_DAY_OF_USE = `${MODULE_NAME}BROWSE_PRINTER_DAY_OF_USE`;
export const CHANGE_PRINTER_PARAM = `${MODULE_NAME}CHANGE_PRINTER_PARAM`;
export const SET_TOTAL = `${MODULE_NAME}SET_TOTAL`;
export const EXPORT_PRINTER_REPORT = `${MODULE_NAME}EXPORT_PRINTER_REPORT`;

export const PAGINATION = {
  size: 10,
  page: 1
};

export const SOS_STATUS = {
  NOT_YET: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3
};
export const PRINTER_TYPE = {
  "0": {
    label: "Wifi",
    value: 0
  },
  "1": {
    label: "Bluetooth",
    value: 1
  }
};
export const PRINTER_STATUS = {
  BROKEN: {
    label: "Bỏ",
    value: "BROKEN"
  },
  FAIL: {
    label: "Hỏng",
    value: "FAIL"
  },
  FIXED: {
    label: "Đã sửa",
    value: "FIXED"
  },
  WORKING: {
    label: "Đang sử dụng",
    value: "WORKING"
  },
  NEW: {
    label: "Ngừng sử dụng",
    value: "NEW"
  }
};

export const DEVICE_STATUS = {
  ONLINE: {
    label: "ONLINE",
    value: "ONLINE",
    color: "#069255"
  },
  OFFLINE: {
    label: "OFFLINE",
    value: "OFFLINE",
    color: "#EB5757"
  }
};

export const SOS_STATUS_TEXT = {
  "1": "Chưa xử lý",
  "2": "Đang xử lý",
  "3": "Đã xử lý"
};

export const PRINT_STATUS_TEXT = {
  "1": "Black list",
  "2": "Bình thường",
  // "3": "Chưa SOS",
  // "4": "Quá hạn 14 ngày",
  "5": "Không hợp lệ"
};

export const PRINTER_MANAGE_STATUS = [
  {
    label: "Đang sử dụng",
    value: "working"
  },
  {
    label: "Tạm dừng hoạt động",
    value: "inactive"
  },
  {
    label: "Không sử dụng",
    value: "inactive_over_1_month"
  }
];

export const PRINTER_MANAGE_STATUS_TEXT = {
  working: "Đang sử dụng",
  inactive: "Tạm dừng hoạt động",
  inactive_over_1_month: "Không sử dụng"
};
